/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Dictionary_unknown_ } from './Dictionary_unknown_';
import type { TCTemplateKind } from './TCTemplateKind';
import type { TCTemplateTrigger } from './TCTemplateTrigger';
/**
 * TSOA-compatible template record.
 */
export type TCTemplateRecord = {
    origin?: string;
    key?: string;
    name?: string;
    description?: string;
    version?: number;
    tags?: Array<string>;
    createdAt?: string;
    updatedAt?: string;
    templateId?: string;
    author?: string;
    references?: Array<{
        required?: boolean;
        alias?: string;
        version: number;
        key: string;
    }>;
    definitionLocation?: ({
        sizeBytes: number;
        type: TCTemplateRecord.type;
    } | {
        s3Key: string;
        s3Bucket: string;
        sizeBytes: number;
        type: TCTemplateRecord.type;
    });
    readme?: string;
    /**
     * Template kind identifier.
     */
    kind: TCTemplateKind;
    /**
     * Template definition payload as a generic dictionary.
     */
    definition?: Dictionary_unknown_;
    /**
     * Optional metadata attached to the template.
     */
    metadata?: Dictionary_unknown_;
    /**
     * Optional template trigger definition.
     */
    trigger?: TCTemplateTrigger;
};
export namespace TCTemplateRecord {
    export enum type {
        INLINE = 'inline',
    }
}

